import React from "react";

const Head = () => {
  return (
    <div className="header">
        <h1>
          Find <span className="vac">Vaccine</span> By PINCODE{" "}
        </h1>
        <i className="fas fa-2x fa-syringe App-logo"> </i>
    </div>
  );
};

export default Head;
